import { ApplicationChildCaregiverStatusScreen } from "@/interactors/ApplicationChildCaregiverStatusScreen";

export default function ChildCaregiverStatus() {
  return <ApplicationChildCaregiverStatusScreen />;
}
